import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFill,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        ...StyleSheet.absoluteFill
    }
});

export const useStyles = ({
    isFocusVisible,
    borderRadius,
    shapeConfigs,
    borders,
    colors
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    borders: NCoreUIKit.Borders;
    isFocusVisible: boolean;
    borderRadius: number;
}) => {
    const styles = {
        container: {
            zIndex: shapeConfigs.layers.raised,
            ...getCornerStyle({
                radius: borderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: borderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
